module.exports = __webpack_public_path__ + "img/ben_nav.7cc8146a.png";